import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M16.7719 8.80876L9.5834 5.93336C9.01396 5.70558 8.37553 6.03937 8.23762 6.63698L6.08107 15.982C5.87561 16.8723 6.87342 17.5492 7.62467 17.0291L16.9697 10.5594C17.6252 10.1056 17.5121 9.10484 16.7719 8.80876Z",
  fill: "currentColor"
}, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "8.5",
  cy: "5.5",
  r: "2.5",
  fill: "currentColor",
  stroke: "currentColor"
}, null, -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "18.5",
  cy: "9.5",
  r: "2.5",
  fill: "currentColor",
  stroke: "currentColor"
}, null, -1 /* HOISTED */)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "5.5",
  cy: "18.5",
  r: "2.5",
  fill: "currentColor",
  stroke: "currentColor"
}, null, -1 /* HOISTED */)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_6))
}
export default { render: render }